import axios from "axios";
import { setCurrentSession } from "@/utils/localStorage";

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL,
});

// Declarando rota default
// instance.defaults.baseURL = process.env.VUE_APP_URL;

// Interceptando requisição
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("userToken");
  config.headers.common["Authorization"] = `Bearer ${token}`;
  return config;
});

// Interceptando resposta
instance.interceptors.response.use(
  (config) => {
    setCurrentSession();
    localStorage.setItem("userToken", config.headers.authorization);
    return config;
  },

  (error) => {
    if (error.response.data.error == "Unauthenticated.") {
      alert("Você não está autenticado!");
      window.location.href = "/";
    }

    if (error.response.status >= 400) {
      if (typeof error.response.data.error !== "string" && error.response.data.error) {
        Object.values(error.response.data.error).forEach((value) => {
        throw value.toString();
        });
      } else {
        throw error.response.data
        // .error || error.response.data;
      }
    }
  }
);

export default instance;
